declare var require: any;

export const environment = {
  production: true,
  environmentName: "production",

  api: {
    umovme:
      "https://api.umov.me/CenterWeb/api/24709e899ae34c12edb5d1dbc7b95dede62bf0/",
    backend: "https://dev-api-sabara.np3tecnologia.com.br/",
  },
};
